export interface MultipleSelectOption {
    id: string;
    value: any;
    label: string;
    selected: boolean;    
    hide: boolean;
    
    toggleSelected();
}

export enum OptionValueSelector {
    Index = 0,
    Value = 1,
    Id = 2
}